import React, { Component } from 'react';
import {
    Grid,
    Button
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl } from 'react-intl';
import Scroll from 'react-scroll';
import cx from 'classnames';
import cs from '../../../components/commonStyle.css';
import s from './WhyHostFaq.css';
import history from '../../../core/history';
import icon from '/public/SiteIcons/arrow-right-white-small.svg';
import { connect } from 'react-redux';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import Loader from '../../Loader';

// Translation
import { FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

const getFaqQuery = gql`
  query getFaq {
    getFaq {
      id
      question
      answer
      category
    }
  }
`;

let Link = Scroll.Link;

class WhyHostFaq extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: null
        };
        this.handleClick = this.handleClick.bind(this);
        this.toggleAccordion = this.toggleAccordion.bind(this);
    }

    toggleAccordion(index) {
        this.setState(prevState => ({
            activeIndex: prevState.activeIndex === index ? null : index
        }));
    }

    handleClick() {
        const { isAuthenticated } = this.props;
        if (isAuthenticated) {
            history.push('/become-a-owner?mode=new');
        } else {
            history.push('/login?refer=/become-a-owner?mode=new');
        }
    }

    render() {
        const { data, faqData } = this.props;
        
        console.log("FAQ Data:", faqData);

        return (
            <div className={s.faqSection}>
                <div className={s.container}>
                    <div className={s.titleContainer}>
                        <h2 className={s.faqTitle}>Got Questions? We've Got Answers</h2>
                    </div>

                    <div className={cx(cs.dFlex, cs.spaceTop6, cs.justifyCenter, s.btnContainer)}>
                        <Button
                            className={cx(s.listButton, cs.btnThemeSecondary)}
                            onClick={this.handleClick}
                        >
                            <span>Get Started</span>
                            <img src={icon} className='imgIconRight' />
                        </Button>
                        <Link
                            to="scrollSection"
                            spy={true}
                            smooth={true}
                            offset={1}
                            duration={500}
                            className={cx(cs.btnThemeSecondaryOutline, s.learnBtnCss, 'learnBtnCssRTL')}
                        >
                            <span>Learn More</span>
                        </Link>
                    </div>

                    <div className={cx(s.FaqList)}>
                        {faqData.loading ? (
                            <Loader type={"text"} />
                        ) : faqData.getFaq && faqData.getFaq.length > 0 ? (
                            faqData.getFaq.map((item) => (
                                <div key={item.id} className={cx(s.FaqItem, this.state.activeIndex === item.id && s.active)}>
                                    <button
                                        className={cx(s.FaqButton, "btn")}
                                        onClick={() => this.toggleAccordion(item.id)}
                                        aria-expanded={this.state.activeIndex === item.id}
                                    >
                                        {item.question}
                                    </button>
                                    <div className={cx(s.FaqContent)}>
                                        {item.answer}
                                    </div>
                                </div>
                            ))
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

const mapState = (state) => ({
    isAuthenticated: state.runtime.isAuthenticated
});

export default compose(
    connect(mapState),
    graphql(getFaqQuery, {
        options: {
            fetchPolicy: 'network-only', // Force fetch from network
            ssr: true
        }
    }),
    injectIntl,
    withStyles(s, cs)
)(WhyHostFaq); 